import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

const fechaLocal = () => {
  const ahora = new Date();
  const offset = ahora.getTimezoneOffset() * 60000;
  return new Date(ahora.getTime() - offset).toISOString().slice(0, 10);
};

export default function useCantinaCierre() {
  const hoy = fechaLocal();

  const [filtros, setFiltros] = useState({
    desde: hoy,
    hasta: hoy,
  });
  const [cierre, setCierre] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    setCargando(true);
    setError('');

    try {
      const response = await api.get('/cantina/ventas/cierre', {
        params: filtros,
      });

      setCierre(response.data);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          'No se pudo cargar el cierre de Cantina'
      );
    } finally {
      setCargando(false);
    }
  }, [filtros]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const actualizarFiltro = (campo, valor) => {
    setFiltros((actuales) => ({
      ...actuales,
      [campo]: valor,
    }));
  };

  return {
    filtros,
    cierre,
    cargando,
    error,
    actualizarFiltro,
    recargar: cargar,
  };
}
